import React, { Component, createRef } from 'react'
import './Partidos.css'
import { auth, database, storage, ref, get, set, child, query, orderByChild, equalTo, limitToFirst, onValue, off, serverTimestamp, storageRef, getDownloadURL } from '../../firebase'
import Loading from '../commons/Loading'
import { BtnPrimary } from '../commons/Buttons'
import { CSSTransition } from 'react-transition-group'
import Alert from '../commons/Alert'
import moment from 'moment'
import 'moment/dist/locale/es'

moment.locale('es')

class Partidos extends Component {
  constructor (props) {
    super(props)
    this.state = {
      id: '',
      fecha: '',
      active: '',
      mode: '',
      rows: [],
      results: [],
      lastModified: null,
      hasResults: false,
      btnEnabled: false,
      saving: false,
      loaded: false,
      alert: null
    }
    this.handleRadio = this.handleRadio.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.getData = this.getData.bind(this)
    this.userId = auth.currentUser.uid
    this.alertRef = createRef()
  }
  componentDidMount () {
    this.getData(this.props.groupId)
      .then((data) => {
        this.setState({
          id: data.quiniela.id,
          fecha: data.quiniela.fecha,
          active: data.quiniela.active,
          desde: data.quiniela.desde,
          hasta: data.quiniela.hasta,
          rows: data.rows,
          results: data.results,
          mode: data.mode,
          loaded: true
        })
        const activeRef = ref(database, 'quinielas/index/' + data.mode + '/' + data.quiniela.id + '/active')
        onValue(activeRef, (snap) => {
          this.setState({
            active: snap.val()
          })
        })
      })
  }
  componentDidUpdate (prevProps) {
    if (this.props.groupId !== prevProps.groupId) {
      this.getData(this.props.groupId)
        .then((data) => {
          this.setState({
            id: data.quiniela.id,
            fecha: data.quiniela.fecha,
            active: data.quiniela.active,
            desde: data.quiniela.desde,
            hasta: data.quiniela.hasta,
            rows: data.rows,
            results: data.results,
            mode: data.mode,
            loaded: true
          })
          const activeRef = ref(database, 'quinielas/index/' + data.mode + '/' + data.quiniela.id + '/active')
          onValue(activeRef, (snap) => {
            this.setState({
              active: snap.val()
            })
          })
        })
    }
  }
  getData (groupId) {
    return new Promise((resolve, reject) => {
      this.setState({
        loaded: false
      })
      const quiniela = {}
      let rows, results, mode
      get(child(child(ref(database, 'grupos/index'), groupId), 'mode'))
        .then((snap) => {
          mode = snap.val()
          const quinielasRef = ref(database, 'quinielas/index/' + mode)
          const q = query(quinielasRef, orderByChild('current'), equalTo(true), limitToFirst(1))
          return get(q)
        })
        .then((snap) => {
          snap.forEach((child) => {
            quiniela.id = child.key
            quiniela.active = child.val().active
            quiniela.fecha = child.val().fecha
            quiniela.desde = child.val().desde
            quiniela.hasta = child.val().hasta
          })
          return get(child(ref(database, 'quinielas/partidos/' + mode), quiniela.id))
        })
        .then((snap) => {
          rows = snap.val()
          return get(child(child(ref(database, 'grupos/resultados'), groupId), quiniela.id + '/' + this.userId))
        })
        .then((snap) => {
          if (snap.val()) {
            results = snap.val()
            return get(child(ref(database, 'grupos/log'), groupId + '/' + quiniela.id + '/' + this.userId))
          } else {
            results = rows.map(() => null)
          }
        })
        .then((snap) => {
          if (snap) {
            this.setState({
              hasResults: true,
              lastModified: moment(snap.val()).format('LLLL')
            })
          } else {
            this.setState({
              hasResults: false,
              lastModified: null
            })
          }
          resolve({ quiniela, rows, results, mode })
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
  componentWillUnmount () {
    const activeRef = ref(database, 'quinielas/index/' + this.state.mode + '/' + this.state.id + '/active')
    off(activeRef)
  }
  handleRadio (val, i) {
    const results = this.state.results
    results[i] = val
    const validate = results.filter((res) => !res)
    if (validate.length <= 0) {
      console.log('Es menor a 0')
      this.setState({
        btnEnabled: true,
        results: results
      })
    } else {
      this.setState({
        btnEnabled: false,
        results: results
      })
    }
  }
  onSubmit () {
    this.setState({
      saving: true
    })
    set(child(ref(database, 'grupos/resultados'), this.props.groupId + '/' + this.state.id + '/' + this.userId), this.state.results)
      .then(() => {
        return set(child(ref(database, 'grupos/log'), this.props.groupId + '/' + this.state.id + '/' + this.userId), serverTimestamp())
      })
      .then(() => {
        this.setState({
          saving: false,
          hasResults: true,
          alert: 'success',
          lastModified: moment().format('LLLL')
        })
      })
      .catch((err) => {
        console.error(err)
        this.errorMsg = err
        this.setState({
          saving: false,
          alert: 'error'
        })
      })
  }
  render () {
    if (this.state.loaded) {
      return (
        <div className='partidos'>
          <div className='partidos__header'>
            <h2>{this.state.fecha}</h2>
            {this.state.active ? <div className='partidos__status partidos__status--active'>Activa</div> : <div className='partidos__status partidos__status--closed'>Cerrada</div>}
          </div>
          <div className='partidos__meta'>
            <div className='partidos__meta__col'>
              <div className='partidos__meta__title'>Período</div>
              <div className='partidos__meta__text'>Del {moment(this.state.desde).format('dddd D')} de {moment(this.state.desde).format('MMMM')} al {moment(this.state.hasta).format('dddd D')} de {moment(this.state.desde).format('MMMM YYYY')}</div>
            </div>
            <div className='partidos__meta__col'>
              <div className='partidos__meta__title'>Cierre</div>
              <div className='partidos__meta__text'>{moment(this.state.desde).format('dddd D')} de {moment(this.state.desde).format('MMMM')} a las {moment(this.state.desde).format('HH:mm')} hrs.</div>
            </div>
          </div>
          <div className='partidos__info'>
            <p>Selecciona entre local, empate o visitante por cada partido. ¿No estás seguro de tus predicciones? no te preocupes, podrás modificar tus resultados las veces que quieras siempre y cuando sea antes del cierre de la jornada.</p>
          </div>
          <div className='partidos__list'>
            {this.state.rows.map((row, i) => <Row {...row} key={i} index={i} handleRadio={this.handleRadio} value={this.state.results[i]} disabled={!this.state.active} />)}
          </div>
          {this.state.lastModified && <div className='partidos__lastModified'>
            <p>Tus resultados se enviaron el: <b>{this.state.lastModified}</b>.</p>
          </div>}
          <div className='partidos__footer'>
            {this.state.active ? <BtnPrimary
              onClick={this.onSubmit}
              disabled={!this.state.btnEnabled || this.state.saving}
            >{this.state.saving ? <Loading /> : this.state.hasResults ? 'Modificar resultados' : 'Guardar resultados'}</BtnPrimary> : <BtnPrimary disabled>El plazo terminó</BtnPrimary>}
          </div>
          <CSSTransition
            in={this.state.alert === 'success'}
            nodeRef={this.alertRef}
            timeout={800}
            classNames={'alert'}
            onClick={() => this.setState({ alert: null })}
            mountOnEnter
            unmountOnExit>
            <div ref={this.alertRef}>
              <Alert type='success'>
                <p>Tus resultados se han enviado correctamente, ¡mucha suerte!</p>
              </Alert>
            </div>
          </CSSTransition>
          <CSSTransition
            in={this.state.alert === 'error'}
            timeout={800}
            classNames={'alert'}
            onClick={() => this.setState({ alert: null })}
            mountOnEnter
            unmountOnExit>
            <Alert type='error'>
              <p>Ocurrió un error al enviar tus resultados, inténtalo nuevamente<br />{this.errorMsg}</p>
            </Alert>
          </CSSTransition>
        </div>
      )
    }
    return (
      <div className='partidos'>
        <div className='partidos__loading'>
          <Loading />
        </div>
      </div>
    )
  }
}

class Row extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: this.props.value,
      localImageUrl: null,
      visitanteImageUrl: null
    }
    this.handleRadio = this.handleRadio.bind(this)
  }
  componentDidMount () {
    if (this.props.localId) {
      const localRef = storageRef(storage, `teams/${this.props.localId}.png`)
      getDownloadURL(localRef)
        .then(url => this.setState({ localImageUrl: url }))
        .catch(() => this.setState({ localImageUrl: null }))
    }
    if (this.props.visitanteId) {
      const visitanteRef = storageRef(storage, `teams/${this.props.visitanteId}.png`)
      getDownloadURL(visitanteRef)
        .then(url => this.setState({ visitanteImageUrl: url }))
        .catch(() => this.setState({ visitanteImageUrl: null }))
    }
  }
  handleRadio (ev) {
    const value = ev.target.value
    this.setState({
      value: value
    })
    this.props.handleRadio(value, this.props.index)
  }
  render () {
    return (
      <div className='partidos__row'>
        <div className='partidos__teams'>
          <div className='partidos__team partidos__team--l'>
            <div className='partidos__team__image'>
              {this.state.localImageUrl ? <img src={this.state.localImageUrl} alt='Logo' /> : null }
            </div>
            <span>{this.props.local}</span>
          </div>
          <div className='partidos__team partidos__team--v'>
            <span>{this.props.visitante}</span>
            <div className='partidos__team__image'>
              {this.state.visitanteImageUrl ? <img src={this.state.visitanteImageUrl} alt='Logo' /> : null }
            </div>
          </div>
        </div>
        <div className='partidos__options'>
          <div className='partidos__option'>
            <input id={'local' + this.props.index} type='radio' name={'res' + this.props.index} value='l' checked={this.state.value === 'l'} onChange={this.handleRadio} disabled={this.props.disabled} />
            <label htmlFor={'local' + this.props.index}>Local</label>
          </div>
          <div className='partidos__option'>
            <input id={'empate' + this.props.index} type='radio' name={'res' + this.props.index} value='e' checked={this.state.value === 'e'} onChange={this.handleRadio} disabled={this.props.disabled} />
            <label htmlFor={'empate' + this.props.index}>Empate</label>
          </div>
          <div className='partidos__option'>
            <input id={'visitante' + this.props.index} type='radio' name={'res' + this.props.index} value='v' checked={this.state.value === 'v'} onChange={this.handleRadio} disabled={this.props.disabled} />
            <label htmlFor={'visitante' + this.props.index}>Visitante</label>
          </div>
        </div>
      </div>
    )
  }
}

export default Partidos
